import React from 'react';
import { Box, Grid, Paper, Typography } from '@mui/material';
import {
  TrendingUp,
  TrendingDown,
  TrendingFlat,
  AccessTime,
  CheckCircleOutline,
  HourglassEmpty,
} from '@mui/icons-material';
import { contentCardSx } from '../../../../styles/standaloneLayoutTokens';

function StatCard({ label, value, sub, icon, delta }) {
  const deltaColor =
    delta > 0 ? 'success.main' : delta < 0 ? 'error.main' : 'text.secondary';
  const DeltaIcon =
    delta > 0 ? TrendingUp : delta < 0 ? TrendingDown : TrendingFlat;

  return (
    <Paper
      elevation={0}
      sx={{ ...contentCardSx, p: 2.5, height: '100%', display: 'flex', flexDirection: 'column' }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
        {icon}
        <Typography variant="body2" color="text.secondary">
          {label}
        </Typography>
      </Box>

      <Typography variant="h4" fontWeight={700} sx={{ mb: 0.5 }}>
        {value ?? '\u2014'}
      </Typography>

      {sub && (
        <Typography variant="caption" color="text.secondary">
          {sub}
        </Typography>
      )}

      {delta !== null && delta !== undefined && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 'auto', pt: 1 }}>
          <DeltaIcon sx={{ fontSize: 16, color: deltaColor }} />
          <Typography variant="caption" sx={{ color: deltaColor }}>
            {delta > 0 ? '+' : ''}
            {delta}% vs yesterday
          </Typography>
        </Box>
      )}
    </Paper>
  );
}

export default function TodaySnapshot({ stats }) {
  if (!stats) return null;

  const waitLabel =
    stats.avgWait !== null ? `${stats.avgWait} min` : '\u2014';

  return (
    <Box sx={{ mb: 4 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Today
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={6} md={3}>
          <StatCard
            label="Check-ins"
            value={stats.total}
            sub={`${stats.qr} QR \u00B7 ${stats.sms} SMS`}
            icon={<CheckCircleOutline fontSize="small" color="primary" />}
            delta={stats.volumeDelta}
          />
        </Grid>

        <Grid item xs={6} md={3}>
          <StatCard
            label="Waiting"
            value={stats.waiting}
            icon={<HourglassEmpty fontSize="small" color="warning" />}
          />
        </Grid>

        <Grid item xs={6} md={3}>
          <StatCard
            label="Avg Wait"
            value={waitLabel}
            icon={<AccessTime fontSize="small" color="info" />}
          />
        </Grid>

        <Grid item xs={6} md={3}>
          <StatCard
            label="Completed"
            value={stats.completed}
            sub={stats.called > 0 ? `${stats.called} in progress` : undefined}
            icon={<CheckCircleOutline fontSize="small" color="success" />}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
